import {Howl} from "howler";
import {gsap} from "../../../../libs/gsap/all.js"

// Constructor
export class Soundscape {

  constructor(...tracks) {

    this.mainVolume = 1;
    this.mainVolumeTween = null;

    this.tracks = [];
    this.tracksVolume = [];

    tracks.forEach((track) => {
      this.tracksVolume.push(0);
      this.tracks.push(new Howl({
        src: [track],
        loop: true,
        autoplay: false,
        volume: 0,
      }));
    })
  }

  updateProgress(value) {
    const crossFadeOverlap = 0.25;
    this.tracksVolume[0] = window.constrain(window.map(value, 0.5, 0.5 + crossFadeOverlap, 1, 0), 0, 1);
    this.tracksVolume[1] = window.constrain(window.map(value, 0.5 - crossFadeOverlap, 0.5, 0, 1), 0, 1);
    this.syncAllHowlerVolume()
  }

  syncAllHowlerVolume() {
    this.tracks.forEach((track, i) => {
      this.setHowlerVolume(track, this.tracksVolume[i] * this.mainVolume)
    })
  }

  setHowlerVolume(track, volume) {
    if (volume <= 0) {
      track.volume(0).stop().seek(0);
    } else {
      if (track.playing() === false) track.play()
      track.volume(volume);
    }
  }

  start() {
    this.killMainVolumeTween();

    this.tracks.forEach((track) => {
      track.seek(0)
    });

    this.updateProgress(0);

    this.mainVolumeTween = gsap.to(this, {
      mainVolume: 1,
      duration: 0.75,
      ease:"quad.in",
      onUpdate: () => {
        this.syncAllHowlerVolume()
      }
    })
  }

  stopAll() {
    this.killMainVolumeTween();
    this.mainVolumeTween = gsap.to(this, {
      mainVolume: 0,
      duration: 0.35,
      ease:"linear",
      onUpdate: () => {
        this.syncAllHowlerVolume()
      }
    })
  }


  killMainVolumeTween() {
    if (this.mainVolumeTween) {
      this.mainVolumeTween.kill()
      this.mainVolumeTween = null;
    }
  }

}
